import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-fixedheader'
import 'multiple-select/dist/multiple-select';
import 'url-polyfill/url-polyfill';

function filterLaw() {
  var lawList = $('.law-list-item');
  var totalItems = lawList.length;
  var filteredResults = 0;

  // The .selected class is necessary to make the "Select all"
  // option show all records when unchecked.

  var selectedTechnologies = $('.tech-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  var selectedUtilities = $('.utility-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  var selectedCounties = $('.county-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  lawList.hide().each(function() {
    var technologyMatch = true;
    if (selectedTechnologies.length > 0 && $("li.tech-check:not(.selected)").length > 0) {
      technologyMatch = doArraysIntersect(selectedTechnologies, $(this).data('technology'));
    }

    var utilityMatch = true;
    if (selectedUtilities.length > 0 && $("li.utility-check:not(.selected)").length > 0) {
      utilityMatch = selectedUtilities.indexOf($(this).data('utility').toString()) !== -1;
    }

    var countyMatch = true;
    if (selectedCounties.length > 0 && $("li.county-check:not(.selected)").length > 0) {
      countyMatch = doArraysIntersect(selectedCounties, $(this).data('county'));
    }

    if (technologyMatch && utilityMatch && countyMatch) {
      $(this).show();
      filteredResults += 1;
    }
  });

  var filteredResultsLabel = filteredResults === 1 ? " result" : " results";
  var totalItemsLabel = totalItems === 1 ? " item" : " items";

  if (filteredResults !== totalItems) {
    $('#resultsCount').text(filteredResults + filteredResultsLabel + " filtered from " + totalItems + totalItemsLabel);
  } else {
    $('#resultsCount').text(totalItems + totalItemsLabel);
  }

  $('ul.filtered-list-items').each(function() {
    $(this).children().last().hide();
    if ($(this).children(':visible').length === 0) {
      $(this).children().last().show();
    }
  });
}

function doArraysIntersect(selectedOptions, lawData) {
  return selectedOptions.some(function(selected) {
    return lawData.some(function(law) {
      return selected.toString() === law.toString();
    });
  });
}

function handleParams() {
  if (window.location.pathname.startsWith('/laws/state_summary') || window.location.pathname.startsWith('/laws/fed_summary')) {
    var url = new URL(location);

    var technologies = [];
    $('li.tech-check.selected input').each(function() {
      technologies.push($(this).attr("value"));
    });

    if (technologies.length > 0) {
      url.searchParams.set('technologies', technologies);
    } else {
      url.searchParams.delete('technologies');
    }

    var utilities = [];
    $('li.utility-check.selected input').each(function() {
      utilities.push($(this).attr("value"));
    });

    if (utilities.length > 0) {
      url.searchParams.set('utilities', utilities);
    } else {
      url.searchParams.delete('utilities');
    }

    var counties = [];
    $('li.county-check.selected input').each(function() {
      counties.push($(this).attr("value"));
    });

    if (counties.length > 0) {
      url.searchParams.set('counties', counties);
    } else {
      url.searchParams.delete('counties');
    }

    if (url.search.length > 0) {
      window.history.replaceState('', document.title, decodeURIComponent(url.search));
    } else {
      window.history.replaceState('', document.title, window.location.pathname);
    }
  }
}

$.fn.dataTableExt.oSort['string-asc']  = function(x,y) {
  if (x == "federal") {
    x = "AAAA"
  }
  if (y == "federal") {
    y = "AAAA"
  }
  return ((x < y) ?  -1 : ((x > y) ? 1 : 0));
};

$.fn.dataTableExt.oSort['string-desc'] = function(x,y) {
  if (x == "federal") {
    x = "AAAA"
  }
  if (y == "federal") {
    y = "AAAA"
  }
  return ((x < y) ?  1 : ((x > y) ? -1 : 0));
};

$(document).ready(function() {
  $('#law_table').dataTable({
    paging: false,
    searching: false,
    info: false,
  });

  $('#matrix_table').dataTable({
    fixedHeader: true,
    paging: false,
    searching: false,
    info: false,
    ordering: false,
  });

  var selectMultipleTech = $('.select-multiple-tech')

  $(selectMultipleTech).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.tech-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.tech-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  var selectMultipleUtility = $('.select-multiple-utility');

  $(selectMultipleUtility).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.utility-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.utility-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  var selectMultipleCounty = $('.select-multiple-county');

  $(selectMultipleCounty).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.county-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.county-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  filterLaw();
  handleParams();

  $("#print").children().click(function(){
    $("#advanced-search").hide();
  });

  $("#print_preview_cancel").click(function(){
    $("#advanced-search").show();
  });

  $(".tli_content_header").click(function(){
    $(this).parent().children(".tli_content_body").toggle();
    $(this).children("i").toggleClass("icon-eere-accordion-plus icon-eere-accordion-minus");
  });

  $("#show_all").click(function(){
    $(".tli_content_body").show();
    $(".tli_content_header").children("i").removeClass("icon-eere-accordion-plus icon-eere-accordion-minus").addClass("icon-eere-accordion-minus");
    $("#show_all").hide();
    $("#hide_all").show();
  });

  $("#hide_all").click(function(){
    $(".tli_content_body").hide();
    $(".tli_content_header").children("i").removeClass("icon-eere-accordion-plus icon-eere-accordion-minus").addClass("icon-eere-accordion-plus");
    $("#hide_all").hide();
    $("#show_all").show();
  });

  // buttons on EV tax credit-page
  if (window.location.pathname.startsWith('/laws/electric-vehicles-for-tax-credit')) {
    $('#list-2022, #list-legacy').hide();
    $('#tab-2023').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#tab-2022, #tab-legacy').removeClass('active');
      $('#list-2022, #list-legacy').hide();
      $('#list-2023, #vin-decoder-section').show();
      window.location.hash = '#/' + 'tab-2023';
    });
    $('#tab-2022').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#tab-2023, #tab-legacy').removeClass('active');
      $('#list-2023, #list-legacy').hide();
      $('#list-2022, #vin-decoder-section').show();
      window.location.hash = '#/' + 'tab-2022';
    });
    $('#tab-legacy').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#tab-2023, #tab-2022').removeClass('active');
      $('#list-2023, #list-2022, #vin-decoder-section').hide();
      $('#list-legacy').show();
      window.location.hash = '#/' + 'tab-legacy';
    });
    var hashId = window.location.hash.replace(/^#\/|^#/, '#');
    if (hashId == "#tab-2023" || hashId == "#tab-2022" || hashId == "#tab-legacy") {
      $(hashId).trigger('click');
    } else {
      $(hashId).prev().trigger('click');
    }
  }

  // buttons on local examples page
  if (window.location.pathname.startsWith('/laws/local_examples')) {
    $('#laws-list').hide();
    $('#laws').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#incentives').removeClass('active');
      $('#incentives-list').hide();
      $('#laws-list').show();
      window.location.hash = '#/' + 'laws';
    });
    $('#incentives').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#laws').removeClass('active');
      $('#laws-list').hide();
      $('#incentives-list').show();
      window.location.hash = '#/' + 'incentives';
    });
    const hashId = window.location.hash.replace(/^#\/|^#/, '#');
    if (hashId == "#laws" || hashId == "#incentives") {
      $(hashId).trigger('click');
    } else if (hashId == "#5" || hashId == "#6" || hashId == "#7" || hashId == "#8" || hashId == "#9") {
      $('#laws').addClass('active');
      $('#incentives').removeClass('active');
      $('#incentives-list').hide();
      $('#laws-list').show();
      $(hashId).trigger('click');
    } else {
      $(hashId).prev().trigger('click');
    }
  }

  // buttons on utility examples page
  if (window.location.pathname.startsWith('/laws/utility-program-development')) {
    $('#commission-list').hide();
    $('#utility-list').hide();
    $('#commission').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#mandates').removeClass('active');
      $('#mandates-list').hide();
      $('#utility').removeClass('active');
      $('#utility-list').hide();
      $('#commission-list').show();
      window.location.hash = '#/' + 'commission';
    });
    $('#utility').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#mandates').removeClass('active');
      $('#mandates-list').hide();
      $('#commission').removeClass('active');
      $('#commission-list').hide();
      $('#utility-list').show();
      window.location.hash = '#/' + 'utility';
    });
    $('#mandates').click(function(e) {
      e.preventDefault();
      $(this).addClass('active');
      $('#utility').removeClass('active');
      $('#utility-list').hide();
      $('#commission').removeClass('active');
      $('#commission-list').hide();
      $('#mandates-list').show();
      window.location.hash = '#/' + 'mandates';
    });
    const hashId = window.location.hash.replace(/^#\/|^#/, '#');
    if (hashId == "#commission" || hashId == "#utility" || hashId == "#mandates") {
      $(hashId).trigger('click');
    }
  }
});
